import PropTypes from 'prop-types';

export default function SendButton({ disabled = false, compact = false, isSubmitting = false }) {
  const sizeClasses = compact ? 'p-2' : 'px-4 py-3';
  const iconSize = compact ? 'w-4 h-4' : 'w-5 h-5';

  return (
    <button
      type="submit"
      disabled={disabled}
      className={`group/btn ${sizeClasses} rounded-lg bg-gradient-to-br from-purple-500 to-purple-600 hover:from-purple-600 hover:to-purple-700 disabled:opacity-40 disabled:cursor-not-allowed transition-all shadow-lg shadow-purple-500/20 hover:shadow-purple-500/30 flex items-center justify-center`}
      style={{ color: 'var(--color-text-on-accent)' }}
      title="Send message"
    >
      {isSubmitting ? (
        <svg className={`${iconSize} animate-spin`} fill="none" viewBox="0 0 24 24">
          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
        </svg>
      ) : (
        <svg className={`${iconSize} [transform:rotate(90deg)] group-hover/btn:animate-[send-arrow_0.6s_ease-in-out]`} fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8" />
        </svg>
      )}
    </button>
  );
}

SendButton.propTypes = {
  disabled: PropTypes.bool,
  compact: PropTypes.bool,
  isSubmitting: PropTypes.bool,
};
